import * as React from "react";
import type { SVGProps } from "react";
export const SvgArrowLineLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24" {...props}>
    <path fill="currentColor" d="m9.171 12.172 4.244-4.243 1.414 1.415-2.83 2.828L14.83 15l-1.415 1.415-4.243-4.243Z" />
  </svg>
);
